import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { RedirectParams } from '../../../../../../shared/types/redirectParams';

import { ProcedureParamsDataProps } from './props';
import { useEffect } from 'react';
import { ParamEnum } from '../../../../../../shared/types/shared';

export const useProcedureParamsData = ({
    data,
    onChangeData,
    onChangeFormik,
}: ProcedureParamsDataProps) => {
    const onSubmit = (data: RedirectParams) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('class', data?.class || ParamEnum.PQR_PROCEDURE);
        formik?.setFieldValue('code', data?.code || '');
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('extra', data?.extra || '');
        formik?.setFieldValue('active', data?.active || '');
    }, [data]);

    return {
        formik,
    };
};
